"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.string.link");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _theme_1 = require("@theme");
const atoms_1 = require("@components/atoms");
const _api_1 = __importDefault(require("@api"));
const _store_1 = __importDefault(require("@store"));
const _utils_1 = require("@utils");
var Bookmarker = function Bookmarker(_ref) {
    var link = _ref.link, metadata = _ref.metadata, imageUrl = _ref.imageUrl, type = _ref.type;
    var _React$useState = react_1.default.useState(), bookmarkId = _React$useState[0], setBookmarkId = _React$useState[1];
    var _useGlobal = _store_1.default(function (state) {
        return state.bookmarks;
    }, function (actions) {
        return actions.setBookmarks;
    }), bookmarks = _useGlobal[0], setBookmarks = _useGlobal[1];
    var _React$useState2 = react_1.default.useState(false), unbookmarked = _React$useState2[0], setUnbookmarked = _React$useState2[1];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.user;
    }, function (actions) {
        return actions.setUser;
    }), user = _useGlobal2[0];
    var _useGlobal3 = _store_1.default(function (state) {
        return state.visibleDropdown;
    }, function (actions) {
        return actions.setVisibleDropdown;
    }), setVisibleDropdown = _useGlobal3[1];
    var _useGlobal4 = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), setPanel = _useGlobal4[1];
    react_1.default.useEffect(function () {
        var found = false;
        bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.map(function (bookmark) {
            if (bookmark.link === link) {
                setBookmarkId(bookmark.id);
                found = true;
            }
        });
        if (!found)
            setBookmarkId(undefined);
    }, [bookmarks]);
    var createBookmark = function createBookmark() {
        if (!user) {
            setPanel('login');
            setVisibleDropdown('account');
            return;
        }
        _api_1.default('createBookmark', {
            link: link,
            imageUrl: imageUrl,
            meta: JSON.stringify(metadata),
            type: type
        }).then(function (r) {
            return r.json().then(function (response) {
                setBookmarkId(response.id);
                _api_1.default('listBookmarks').then(function (r) {
                    return r.json().then(function (bookmarks) {
                        return setBookmarks(bookmarks);
                    });
                });
            });
        });
    };
    var deleteBookmark = function deleteBookmark() {
        return _api_1.default('deleteBookmark', {
            id: bookmarkId
        }).then(function () {
            setBookmarkId(undefined);
            setUnbookmarked(true);
            _api_1.default('listBookmarks').then(function (r) {
                return r.json().then(function (bookmarks) {
                    return setBookmarks(bookmarks);
                });
            });
        });
    };
    var toggleBookmark = function toggleBookmark() {
        return bookmarkId ? deleteBookmark() : createBookmark();
    };
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(Trigger, {
        onClick: toggleBookmark
    }, !bookmarkId && /*#__PURE__*/ react_1.default.createElement(StyledToolIcon, Object.assign({
        withMobile: true
    }, {
        unbookmarked: unbookmarked
    }), "bookmark"), !!bookmarkId && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(StyledBlurToolIcon, {
        withMobile: true
    }, "heartfill"), /*#__PURE__*/ react_1.default.createElement(IconHoverBase, null, /*#__PURE__*/ react_1.default.createElement(StyledHoverToolIcon, {
        withMobile: true
    }, "heartbroken")))));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "Bookmarker__Wrapper",
    componentId: "sc-1wjmz7m-0"
})(["position:relative;display:flex;align-items:center;justify-content:center;height:100%;width:64px;"]);
var Trigger = styled_components_1.default.div.withConfig({
    displayName: "Bookmarker__Trigger",
    componentId: "sc-1wjmz7m-1"
})(["position:relative;display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&::after{position:absolute;left:50%;bottom:0px;background-color:", ";width:100%;height:2px;transform-origin:center;transform:translate3d(-50%,0,0) scaleX(0);transition:transform 0.3s cubic-bezier(0.645,0.045,0.355,1);will-change:transform;content:'';}&.active::after{transform:translate3d(-50%,0,0) scaleX(1);}", "{&:hover::after{transform:translate3d(-50%,0,0) scaleX(1);}}"], _theme_1.palette.brown, _utils_1.mediaQuery('tablet'));
var StyledToolIcon = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Icon, props);
}).withConfig({
    displayName: "Bookmarker__StyledToolIcon",
    componentId: "sc-1wjmz7m-2"
})(["background-color:", ";", " transform:translate3d(0,0,0);will-change:transform;@keyframes shake{10%,90%{transform:translate3d(-1px,0,0);}20%,80%{transform:translate3d(2px,0,0);}30%,50%,70%{transform:translate3d(-4px,0,0);}40%,60%{transform:translate3d(4px,0,0);}}"], _theme_1.palette.ink, function (props) {
    return props.unbookmarked && "animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;";
});
var StyledBlurToolIcon = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Icon, props);
}).withConfig({
    displayName: "Bookmarker__StyledBlurToolIcon",
    componentId: "sc-1wjmz7m-3"
})(["background-color:", ";transform:scale3d(0.8,0.8,1);animation:pulse 0.6s ease-in-out 0s 1 forwards;will-change:transform;@keyframes pulse{0%{transform:scale3d(0.8,0.8,1);}40%{transform:scale3d(1.2,1.2,1);}70%{transform:scale3d(0.9,0.9,1);}100%{transform:scale3d(1,1,1);}}"], _theme_1.palette.vermillion);
var IconHoverBase = styled_components_1.default.div.withConfig({
    displayName: "Bookmarker__IconHoverBase",
    componentId: "sc-1wjmz7m-4"
})(["position:absolute;background-color:", ";pointer-events:none;opacity:0;transform:scale3d(0,0,1);transition:opacity 0.25s ease-in-out;animation:appear 0.25s ease-in-out 0.25s 1 forwards;will-change:transform;@keyframes appear{0%{transform:scale3d(0,0,1);}100%{transform:scale3d(1,1,1);}}", "{", ":hover &{opacity:1;animation-play-state:paused;}}"], _theme_1.palette.snow, _utils_1.mediaQuery('tablet'), Trigger);
var StyledHoverToolIcon = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Icon, props);
}).withConfig({
    displayName: "Bookmarker__StyledHoverToolIcon",
    componentId: "sc-1wjmz7m-5"
})(["background-color:", ";"], _theme_1.palette.ink); // Typing
exports.default = Bookmarker;
